import { render, staticRenderFns } from "./warningReminder.vue?vue&type=template&id=7ae99073&scoped=true"
import script from "./warningReminder.vue?vue&type=script&lang=js"
export * from "./warningReminder.vue?vue&type=script&lang=js"
import style0 from "./warningReminder.vue?vue&type=style&index=0&id=7ae99073&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae99073",
  null
  
)

export default component.exports